import styled from 'styled-components'
import externalLinkIcon from '../../asset/external-link.svg'
import theme from '../../styles/theme'

export const Footer = styled.footer`
  box-shadow: ${({ haveShadow }) =>
    haveShadow ? 'inset 0px 4px 0px #808080' : 'none'};
  width: 100%;
  padding: 16px;
  margin-right: auto;
  margin-left: auto;
  // margin-top: 0px;
  background-color: ${theme.color.bgShade};
  color: ${theme.color.black};
`

export const CardText = styled.div`
  padding: ${({ isDepenednt }) => (isDepenednt ? '30px 0px' : '0px')};
  margin-top: 0;
  margin-bottom: 10px;
  line-height: 1.5;
  & > a {
    text-decoration: underline;
  }
  & > p {
    margin: 0px;
    line-height: 1.5;
    & > a {
      text-decoration: underline;
      :after {
        display: inline-block;
        content: '';
        background-image: url(${externalLinkIcon});
        background-size: 15px 15px;
        height: 15px;
        width: 15px;
      }

      &:hover {
        color: ${theme.color.text};
      }
    }
`
